import { combineReducers } from 'redux';
import NewProduct from './NewProduct/newproduct.reducer';
import Utils from './Utils/utils.reducer';

export default combineReducers({
  NewProduct,
  Utils
});
